// Meta Pixel utility functions
declare global {
  interface Window {
    fbq: (action: string, event: string, params?: Record<string, any>) => void
    _fbq: any
  }
}

export function initMetaPixel() {
  // Meta Pixel Code
  ;(function (f: any, b: any, e: string, v: string, n: any, t: any, s: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  )

  window.fbq('init', '1993358478061319')
  window.fbq('track', 'PageView')
}

export function trackAddToCart(productData: {
  content_name: string
  value: number
  currency: string
}) {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', productData)
  }
}
